import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles({
  avatar: {
  },
});

export default function AddAgentModal({ onClose, open, user, agents }) {
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">Add an agent for {user.name}</DialogTitle>
      <List>
        {agents.map((agent) => (
          <ListItem button onClick={() => handleListItemClick(agent.id)} key={agent.id}>
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
                {agent.name.substr(0,1)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={agent.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

AddAgentModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
